/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, EventEmitter, Input, Output, inject, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { BaseFormControlComponent } from '../base-form-control.component'
import { DynamicFormLayout, DynamicFormLayoutService } from '../../../service/dynamic-form-layout.service'
import { DynamicFormControlLayout } from '../../../model/misc/dynamic-form-control-layout.model'
import { DynamicCheckboxModel } from '../../../model/checkbox/dynamic-checkbox.model'
import { DynamicFormValidationService } from '../../../service/dynamic-form-validation.service'

@Component({
  selector: 'dynamic-basic-checkbox',
  templateUrl: './dynamic-basic-checkbox.component.html',
  styles: [':host ::ng-deep [slot="label"] a { text-decoration: underline; }'],
  standalone: false,
  // Angular 22 changed the implicit default to OnPush (see angular/angular#67687). This component was never migrated
  // to OnPush semantics, so Eager restores the pre-v22 behaviour it relies on.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DynamicBasicCheckboxComponent extends BaseFormControlComponent {
  // @ts-ignore
  layoutService: DynamicFormLayoutService
  // @ts-ignore
  validationService: DynamicFormValidationService

  get controlState(): 'error' | 'none' {
    return this.isInvalid && this.control.touched ? 'error' : 'none'
  }

  // @ts-ignore
  @Input() formLayout: DynamicFormLayout
  // @ts-ignore
  @Input() group: UntypedFormGroup
  // @ts-ignore
  @Input() layout: DynamicFormControlLayout
  // @ts-ignore
  @Input() model: DynamicCheckboxModel

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() blur: EventEmitter<any> = new EventEmitter()
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change: EventEmitter<any> = new EventEmitter()
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() focus: EventEmitter<any> = new EventEmitter()

  public onChange($event: any) {
    if ($event instanceof Event) {
      $event.stopPropagation()
    }

    const control = this.group.get(this.model.id)
    if (!!this.model.openURLOnClick && control?.value === true) {
      window.open(this.model.openURLOnClick, '_blank')
    }

    this.change.emit($event)
  }

  constructor() {
    const layoutService = inject(DynamicFormLayoutService)
    const validationService = inject(DynamicFormValidationService)
    super()
    this.layoutService = layoutService
    this.validationService = validationService
  }
}
